var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20078 0.400391C1.8753 0.400391 0.800781 1.47491 0.800781 2.80039V17.2004C0.800781 18.5259 1.8753 19.6004 3.20078 19.6004H12.8008C14.1263 19.6004 15.2008 18.5259 15.2008 17.2004V6.89745C15.2008 6.26093 14.9479 5.65048 14.4978 5.20039L10.4008 1.10333C9.9507 0.653247 9.34025 0.400391 8.70373 0.400391H3.20078ZM4.40078 10.0004C3.73804 10.0004 3.20078 10.5376 3.20078 11.2004C3.20078 11.8631 3.73804 12.4004 4.40078 12.4004H11.6008C12.2635 12.4004 12.8008 11.8631 12.8008 11.2004C12.8008 10.5376 12.2635 10.0004 11.6008 10.0004H4.40078Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.33d59bd77a66b5b9899da0efff1b2037.svg";
export { ForwardRef as ReactComponent };